import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logoZitata from '../assets/images/logo_zitata.png';

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!email) {
      setError('Veuillez saisir votre adresse email');
      return;
    }

    try {
      setError('');
      setLoading(true);
      
      // Appel API simplifié - import dynamique pour éviter les problèmes de chargement
      const authService = (await import('../services/auth.service')).default;
      await authService.forgotPassword(email);
      setSuccess(true);
    } catch (err: any) {
      // On affiche toujours un message de succès pour des raisons de sécurité
      setSuccess(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ 
      background: '#121212', 
      minHeight: '100vh', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      color: '#fff',
      fontFamily: "system-ui, -apple-system, sans-serif"
    }}>
      <div style={{
        background: '#23262a',
        borderRadius: '12px',
        padding: '48px',
        width: '100%',
        maxWidth: '400px',
        boxShadow: '0 8px 32px rgba(0,0,0,0.4)',
        border: '1px solid #353a40'
      }}>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <img 
            src={logoZitata} 
            alt="Zitata" 
            style={{
              height: '160px',
              marginBottom: '16px',
              maxWidth: '100%'
            }}
          />
          <h1 style={{
            fontSize: '1.25rem',
            fontWeight: '600',
            margin: '0 0 8px 0',
            color: '#fff'
          }}>
            Mot de passe oublié
          </h1>
          <p style={{
            fontSize: '0.9rem',
            color: '#94a3b8',
            margin: 0
          }}>
            Entrez votre email pour réinitialiser votre mot de passe
          </p>
        </div>

        {success ? (
          // Message de succès
          <div>
            <div style={{
              background: 'rgba(34, 197, 94, 0.1)',
              border: '1px solid rgba(34, 197, 94, 0.3)',
              color: '#4ade80',
              padding: '16px',
              borderRadius: '8px',
              marginBottom: '24px',
              textAlign: 'center'
            }}>
              <div style={{ fontSize: '2rem', marginBottom: '12px' }}>✓</div>
              <p style={{ margin: '0 0 8px 0', fontWeight: '600' }}>
                Email envoyé !
              </p>
              <p style={{ margin: 0, fontSize: '0.85rem', color: '#94a3b8' }}>
                Si un compte existe avec cette adresse email, vous recevrez un lien de réinitialisation.
              </p>
            </div>
            
            <Link 
              to="/login"
              style={{
                display: 'block',
                textAlign: 'center',
                color: '#f59e0b',
                textDecoration: 'none',
                fontWeight: '500',
                fontSize: '0.9rem'
              }}
            >
              ← Retour à la connexion
            </Link>
          </div>
        ) : (
          // Formulaire
          <form onSubmit={handleSubmit}>
            {/* Error Message */}
            {error && (
              <div style={{
                background: 'rgba(239, 68, 68, 0.1)',
                border: '1px solid rgba(239, 68, 68, 0.3)',
                color: '#f87171',
                padding: '12px 16px',
                borderRadius: '8px',
                marginBottom: '24px',
                fontSize: '0.9em',
                fontWeight: '500'
              }}>
                {error}
              </div>
            )}

            <div style={{ marginBottom: '24px' }}>
              <label style={{ 
                display: 'block', 
                marginBottom: '8px', 
                fontWeight: '500',
                color: '#94a3b8',
                fontSize: '0.875rem'
              }}>
                Adresse email
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                style={{
                  width: '100%',
                  padding: '14px 16px',
                  background: '#121212',
                  border: '1px solid #353a40',
                  borderRadius: '8px',
                  color: '#fff',
                  fontSize: '1rem',
                  fontFamily: "system-ui, -apple-system, sans-serif",
                  boxSizing: 'border-box'
                }}
                placeholder="exemple@email.com"
                disabled={loading}
                autoComplete="email"
                autoFocus
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              style={{
                width: '100%',
                padding: '14px',
                background: loading ? '#353a40' : '#f59e0b',
                color: '#121212',
                border: 'none',
                borderRadius: '8px',
                fontSize: '1rem',
                fontWeight: '600',
                cursor: loading ? 'not-allowed' : 'pointer',
                transition: 'all 0.2s ease',
                fontFamily: "system-ui, -apple-system, sans-serif",
                marginBottom: '16px'
              }}
            >
              {loading ? 'Envoi en cours...' : 'Envoyer le lien de réinitialisation'}
            </button>

            <Link 
              to="/login"
              style={{
                display: 'block',
                textAlign: 'center',
                color: '#64748b',
                textDecoration: 'none',
                fontSize: '0.9rem'
              }}
            >
              ← Retour à la connexion
            </Link>
          </form>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
